import store from '@/store/index.js'
import { useGlobals } from '@/main.js'
import DateHeader from '../../HeaderCells/DateHeader.vue'

export const registerCreatedAtColumn = (dashboard, { visible } = { visible: true }) => {
  const { $format } = useGlobals()

  dashboard.registerColumn({
    name: 'created_at',
    label: 'monolith.shared.created_at',
    options: {
      format: $format.date,
      searchable: store.getters.getConfig.SHOW_DATE_FILTERS,
      headerComponent: DateHeader,
      visible,
    },
  })
}
